import React from "react";
import { X } from "lucide-react";

const ContactModal = ({
  showContactModal,
  setShowContactModal,
  userData,
}) => {
  if (!showContactModal) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-end md:items-center justify-center z-50"
      onClick={() => setShowContactModal(false)}
    >
      <div
        className="bg-white w-full md:max-w-md shadow-2xl rounded-t-3xl md:rounded-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-4 border-b border-gray-100 flex items-center justify-between">
          <h3 className="text-xl font-bold text-gray-900">
            Contact Information
          </h3>
          <button
            onClick={() => setShowContactModal(false)}
            className="hidden md:flex w-9 h-9 rounded-full hover:bg-gray-200 flex items-center justify-center"
          >
            <X className="w-5 h-5 text-black" />
          </button>
        </div>

        {/* Body */}
        <div className="p-4">
          {userData?.email ? (
            <div className="flex items-start gap-3">
              <div>
                <p className="text-sm font-semibold text-gray-900">
                  Email
                </p>
                <p className="text-sm text-gray-600 break-all">
                  {userData.email}
                </p>
              </div>
            </div>
          ) : (
            <p className="text-sm text-gray-500 text-center">
              No email available
            </p>
          )}
        </div>

        {/* Footer */}
        <div className="p-2 border-t border-gray-100 bg-gray-50 rounded-b-3xl md:rounded-b-2xl">
          <p className="text-xs text-gray-500 text-center">
            Contact information is provided by {userData?.username}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
